import {
  Component,
  ElementRef,
  EventEmitter,
  Input, OnInit,
  Output,
  QueryList, ViewChild,
  ViewChildren
} from '@angular/core';
import {InfluencerPost} from '../../../../models/influencer';
import {Masonry} from '../../../../../node_modules/ng-masonry-grid';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import { InfluencerOverviewPostContentComponent } from '../post-list/influencer-overview-post-content/influencer-overview-post-content.component';
import { UserService } from '../../../services/user.service';

enum CssEnum {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
  MAX_CONTENT = 'max-content'
}

enum ShowMore {
  MIN_POST = 10
}

@Component({
  selector: 'post-list-mansonry',
  templateUrl: './post-list-mansonry.component.html',
  styleUrls: ['./post-list-mansonry.component.scss']
})
export class PostListMansonryComponent implements OnInit {
  static COMPONENT_NAME = 'PostListMansonryComponent';
  @ViewChild('popup')
  public popup: ElementRef;
  @ViewChild('popupcontainer')
  public popupcontainer: ElementRef;
  @ViewChild('postListContainer')
  public postListContainer: ElementRef;
  @ViewChildren(InfluencerOverviewPostContentComponent)
  postItems: QueryList<InfluencerOverviewPostContentComponent>;

  @Input() postList: Array<InfluencerPost>;
  @Input() influencerGroupId: number;
  @Input() showMoreheight: string;
  @Input() previewMode: boolean | false;
  @Input() target: string;
  @Input() displayMode = 'desktop';
  @Output()
  public selectToPreviewPost: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public openIncompleteStory: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  bottomBar: any;
  @Input()
  columnWidth: any;
  @Input()
  gutter: number;
  @Input()
  keepOrder = false;
  @Output()
  public isLayoutCompleted: EventEmitter<any> = new EventEmitter<any>();

  public activePost = null;

  public height: string;
  public overflow: string;
  private keepHoverPopup: boolean;

  _masonry: Masonry;
  public currentInfluencer;

  constructor(
    private pdfService: PdfExportService,
    private userService: UserService
    ) {}

  ngOnInit() {
    if (this.postList && this.postList.length > ShowMore.MIN_POST) {
      this.height = this.showMoreheight;
      this.overflow = CssEnum.HIDDEN;
    } else {
      this.height = CssEnum.MAX_CONTENT;
      this.overflow = CssEnum.VISIBLE;
    }
    this.currentInfluencer = this.userService.getInfluencerInfo();
  }

  // Get ng masonry grid instance first
  onNgMasonryInit($event: Masonry) {
    this._masonry = $event;
  }

  layoutComplete (laidOutItems ) {
    if (this._masonry) {
      if (laidOutItems && this._masonry.items.length === this.postList.length) {
        this.pdfService.incrementNumberReportReady(PostListMansonryComponent.COMPONENT_NAME);
      }

      if (Array.isArray(laidOutItems) && laidOutItems.length === this.postList.length) {
        this.isLayoutCompleted.emit(true);
      }
    }
  }

  showMore() {
    this.height = CssEnum.MAX_CONTENT;
    this.overflow = CssEnum.VISIBLE;
  }

  prependItems(newItems) {
    if (this._masonry) {
      // set status to 'prepend' before adding items to NgMasonryGrid otherwise default: 'append' will applied
      this._masonry.setAddStatus('prepend');
      this.postList.splice(0, 0, ...newItems);
    }
  }

  onSelectedPost(influencer: InfluencerPost) {
    this.selectToPreviewPost.emit(influencer);
  }

  addToPreviewed(item) {
    this.selectToPreviewPost.emit(item);
  }

  public hidePopupCardHover (evt?) {
    const clickingOnImage = evt && evt.target && evt.target.classList.length > 0 && evt.target.classList.contains('post-img');
    if (this.popup && !this.keepHoverPopup && !clickingOnImage) {
      this.popup.nativeElement.style.display = 'none';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list-mansonry/post-list-mansonry.component.ts